import firebase from "firebase"
import { db, auth } from "../../../../utils/firebase"

/**
 * Append an activity entry to a parent document's `activity` subcollection.
 * Used by both manual agent actions (composer) and automatic system events
 * (status diffs, tag changes, etc). `basePath` is the dotted path to the
 * parent document, e.g. `enquiries/{id}` or `bookings/{id}`.
 *
 * `extras` lets callers attach optional structured fields — currently
 * `link_to` + `link_label` for entries that should render a clickable
 * reference (see entry.js). Kept as a generic bag to avoid having to
 * touch this signature every time a new metadata field shows up.
 */
export async function logActivity(basePath, type, body = "", extras = {}) {
	if (!basePath || !type) return
	await db.collection(`${basePath}/activity`).add({
		type,
		body,
		user: auth.currentUser?.uid || null,
		created: firebase.firestore.FieldValue.serverTimestamp(),
		...extras,
	})
}

const STATUS_LABELS = {
	HOT: "Hot",
	FREEPHONE: "Freephone",
	BEING_PROCESSED: "Processing",
	REQUIRE_ATTENTION: "Require attention",
	ARCHIVE: "Archive",
}

export const statusLabel = (s) => STATUS_LABELS[s] || s || "—"
